export const menuTitle = { title: "RELIGION", label: "Religion" }
  